import { useFetchById } from '../reactQuery';
import { INPUT_API } from '../../../constant/api_url';
import { Input } from '../../../types/input.types';

export const useInputById = (id: number | string) => useFetchById<Input>(`${INPUT_API}/${id}`, id);
